import { Reducer } from 'react';

import { ITranslations } from '@model';
import { EPage } from '@types';

export interface ILocalizationReducer {
  translationsReady: boolean;
  translations: ITranslations;
}

interface IUpdateTranslations {
  translations: ITranslations;
}

export enum ELocalizationActions {
  UPDATE_TRANSLATIONS,
  LOCALIZATION_STATE_UNREADY,
  LOCALIZATION_STATE_READY,
}

export type LocalizationAction =
  | { actionType: ELocalizationActions.UPDATE_TRANSLATIONS; payload: IUpdateTranslations }
  | { actionType: ELocalizationActions.LOCALIZATION_STATE_UNREADY }
  | { actionType: ELocalizationActions.LOCALIZATION_STATE_READY };

export interface ILocalizationActions {
  triggerTranslationLoad: (page: EPage) => void;
}

export type LocalizationReducer = Reducer<ILocalizationReducer, LocalizationAction>;
